import React from "react";
import LegalPageShell from "../components/LegalPageShell";

/**
 * Note legali — pagina con dati aziendali (Art. 2250 c.c.) e clausole d'uso
 * essenziali per il portale (modello "lite": il servizio è gratuito e i
 * servizi Pro sono erogati a seguito di consulenza personale, senza vincoli
 * di durata né contratto formale).
 */
export default function NoteLegali() {
  const Section = ({ title, children }) => (
    <section className="space-y-3">
      <h2 className="font-display text-lg sm:text-xl tracking-tight text-[var(--mp-ink)]">
        {title}
      </h2>
      <div className="text-sm leading-relaxed text-[var(--mp-ink)]/85 space-y-2">
        {children}
      </div>
    </section>
  );

  return (
    <LegalPageShell
      title="Note Legali"
      subtitle="Informazioni societarie obbligatorie ai sensi dell'Art. 2250 del Codice Civile e condizioni essenziali di utilizzo del portale."
      testid="page-note-legali"
    >
      <div className="rounded-3xl border border-[var(--mp-ink)] bg-white shadow-brutal-sm p-6 sm:p-10 space-y-10">
        <Section title="Titolare del portale">
          <p>
            <strong>Marketing Parrucchieri S.r.l.</strong>
            <br />
            Via Prestinari 4 — 20080 Besate (MI) — Italia
            <br />
            Partita IVA: 11579150969
            <br />
            Email: <a href="mailto:info@marketingparrucchieri.info" className="underline">info@marketingparrucchieri.info</a>
            <br />
            PEC: <a href="mailto:marketingparrucchieri@legalmail.it" className="underline">marketingparrucchieri@legalmail.it</a>
          </p>
        </Section>

        <Section title="Natura del servizio">
          <p>
            Il presente portale è un servizio digitale offerto da Marketing Parrucchieri S.r.l.
            ai propri clienti e collaboratori per la gestione operativa di contenuti, programmazione
            social e archiviazione di materiali audiovisivi.
          </p>
          <p>
            <strong>L'accesso base al portale è gratuito.</strong> Eventuali servizi aggiuntivi
            ("Pro") sono erogati a seguito di una consulenza personale e si svolgono in regime di
            collaborazione professionale diretta tra le parti, <strong>senza vincoli di durata
            minima e terminabili in qualsiasi momento</strong> da entrambi con semplice comunicazione
            scritta (email).
          </p>
        </Section>

        <Section title="Uso del portale">
          <p>
            L'utente si impegna a utilizzare il portale per finalità professionali lecite,
            a non caricare contenuti illegali, diffamatori, lesivi di diritti di terzi o
            protetti da copyright senza autorizzazione, e a non condividere le proprie
            credenziali di accesso.
          </p>
          <p>
            Marketing Parrucchieri S.r.l. si riserva il diritto di sospendere o
            cancellare account in caso di violazione delle presenti note o di abuso
            del servizio, dandone preventiva comunicazione laddove possibile.
          </p>
        </Section>

        <Section title="Limitazione di responsabilità">
          <p>
            Il portale è fornito "così com'è". Pur impegnandoci a garantire la massima
            continuità del servizio, non possiamo garantire un uptime del 100% e non ci
            assumiamo responsabilità per eventuali malfunzionamenti dei servizi terzi
            integrati (Telegram, Dropbox, Brevo, Metricool, fornitori di intelligenza
            artificiale) che esulano dal nostro controllo diretto.
          </p>
          <p>
            La responsabilità di Marketing Parrucchieri S.r.l. è in ogni caso limitata
            al valore dei corrispettivi eventualmente percepiti per i servizi a pagamento
            negli ultimi 3 mesi.
          </p>
        </Section>

        <Section title="Proprietà dei contenuti">
          <p>
            I contenuti caricati dall'utente (foto, video, testi, audio) restano di sua
            esclusiva proprietà. Caricandoli, l'utente concede a Marketing Parrucchieri S.r.l.
            una licenza non esclusiva, limitata e revocabile per gestirli, archiviarli e
            pubblicarli sui canali social esplicitamente concordati, esclusivamente per
            la durata del rapporto.
          </p>
        </Section>

        <Section title="Privacy e cookie">
          <p>
            Il trattamento dei dati personali è descritto nella{" "}
            <a href="/privacy-policy" className="underline font-semibold">
              Privacy Policy
            </a>{" "}
            e nella{" "}
            <a href="/cookie-policy" className="underline font-semibold">
              Cookie Policy
            </a>
            , parti integranti delle presenti note.
          </p>
        </Section>

        <Section title="Modifiche">
          <p>
            Le presenti note potranno essere aggiornate. In caso di modifiche sostanziali,
            sarà data comunicazione agli utenti registrati via email con almeno 30 giorni
            di preavviso, con possibilità di opporsi recedendo dal servizio.
          </p>
        </Section>

        <Section title="Legge applicabile e foro competente">
          <p>
            Le presenti note sono regolate dalla legge italiana. Per ogni controversia
            è competente in via esclusiva il <strong>Foro di Milano</strong>, fatte salve
            le competenze inderogabili previste dalla legge per i consumatori.
          </p>
        </Section>

        <div className="pt-4 text-[11px] text-[var(--mp-muted)] italic border-t border-[var(--mp-border)]">
          Ultimo aggiornamento: maggio 2026
        </div>
      </div>
    </LegalPageShell>
  );
}
